/*
 * Form validation for all site pages
 * Extends jquery.validation library
 */
$(function () {

    //common error messages
    var errorMessages = {
        email: "Please enter a valid email address",
        firstName: "Please enter your first name",
        lastName: "Please enter your last name",
        company: "Please enter your company's name",
        title: "Please enter your role at the company",
        paypal: "Please enter a valid email address as your paypal id",
        writer_capacity: "Please enter your average time to complete a 500 word article",
        country: "Please enter the country in which you live",
        bank_acc_holder_name: "Please enter a valid account holder name",
        bank_branch_name: "Please enter a valid bank branch name",
        bank_ifsc_code: "Please enter a valid bank ifsc code",
        bank_account_no: "Please enter a valid bank account number",
        pan: "Please enter a valid PAN number"
    };

    //standard error class
    var standardErrorClass = "validation-error-msg";

    // INDIVIDUAL SITE FORM VALIDATION BELOW

    // signup.htm
    $("#signupform").validate({
        rules: {
            email_work : {
                required : true,
                email : true
        },
            company: 'required',
            firstName: 'required',
            lastName: 'required'
        },
        messages: {
            firstName : errorMessages.firstName,
            lastName : errorMessages.lastName,
            email_work : errorMessages.email,
            company: errorMessages.company
        },
        errorClass: standardErrorClass,
        submitHandler: function(form) {
            form.submit();
        }
    });

    // contactus.htm
    $("#contactus").validate({
        rules: {
            email : {
                required : true,
                email : true
            },
            name: 'required'
        },
        messages: {
            firstName : errorMessages.firstName,
            lastName : errorMessages.lastName,
            email : errorMessages.email
        },
        errorClass: standardErrorClass,
        submitHandler: function(form) {
            form.submit();
        }
    });

    // requestademo.htm
    $("#requestDemo").validate({
        rules: {
            email_work : {
                required : true,
                email : true
            },
            company: 'required',
            firstName: 'required',
            lastName: 'required'
        },
        messages: {
            firstName : errorMessages.firstName,
            lastName : errorMessages.lastName,
            email_work : errorMessages.email,
            company: errorMessages.company
        },
        errorClass: standardErrorClass,
        submitHandler: function(form) {
            form.submit();
        }
    });

    //contributor sign up
    $("#findWork").validate({
        rules: {
            firstName: {
                required : true,
                minlength: 2
            },
            lastName : "required",
            email : {
                required : true,
                email : true
            },
            paypal : {
                required : true,
                email : true
            },
            bank_acc_holder_name : "required",
            bank_branch_name : "required",
            bank_ifsc_code : "required",
            bank_account_no : "required",
            country : "required",
            consider_editor : "required",
            writer_capacity : "required"
        },
        messages: {
            firstName: errorMessages.firstName,
            lastName: errorMessages.lastName,
            email: errorMessages.email,
            company: errorMessages.company,
            paypal: errorMessages.paypal,
            bank_acc_holder_name : errorMessages.bank_acc_holder_name,
            bank_branch_name : errorMessages.bank_branch_name,
            bank_ifsc_code : errorMessages.bank_ifsc_code,
            bank_account_no : errorMessages.bank_account_no
        },

        errorClass: standardErrorClass,
        submitHandler: function(form) {
            form.submit();
        },
        errorPlacement : function(error, element) {
            if (element.attr("type") === "radio" || element.attr("type") === "checkbox") {
                error.insertBefore(element);
            } else {
                error.insertAfter(element);
            }
        }
    });

    $("#toggle").hide("fast");
    $("input[name='keywordradio']").change(function(){
        var keyword = $('input:radio[name=keywordradio]:checked').val();
        if(keyword==="Use my keywords"){
            $("#toggle").show();
        }else{
            $("#toggle").hide();
        }
    });

    $("#checkoutasaguest").find('input').attr('disabled',true);
    $("#login").find('input').attr('disabled',false);
    $('#guest').change(function() {
        guestStatus = $('input:checkbox[name=guest]:checked').val();
        if(guestStatus==="true"){
            $("#checkoutasaguest").find('input').attr('disabled',false);
            $("#login").find('input').attr('disabled',true);
        }
        else{
            $("#checkoutasaguest").find('input').attr('disabled',true);
            $("#login").find('input').attr('disabled',false);
        }
    });
});


